import { forwardRef, ButtonHTMLAttributes, ReactNode } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cn } from './cn';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  fullWidth?: boolean;
  asChild?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = 'primary',
    size = 'md',
    loading = false,
    disabled,
    iconLeft,
    iconRight,
    fullWidth,
    asChild = false,
    className,
    children,
    ...rest
  },
  ref
) {
  const Comp: any = asChild ? Slot : 'button';
  const isDisabled = disabled || loading;

  const content = asChild ? (
    children
  ) : (
    <>
      {iconLeft && (
        <span className="tss-btn__icon" aria-hidden="true">
          {iconLeft}
        </span>
      )}
      <span className="tss-btn__label">{children}</span>
      {iconRight && (
        <span className="tss-btn__icon" aria-hidden="true">
          {iconRight}
        </span>
      )}
    </>
  );

  return (
    <Comp
      ref={ref}
      data-tss-ui=""
      data-variant={variant}
      data-size={size}
      data-loading={loading || undefined}
      data-full-width={fullWidth || undefined}
      className={cn('tss-btn', className)}
      disabled={asChild ? undefined : isDisabled}
      aria-disabled={isDisabled || undefined}
      {...rest}
    >
      {content}
    </Comp>
  );
});
